export default __webpack_public_path__ + "static/media/HorizontalTank_ti40042.35823649.png";